export default "__VITE_ASSET__bcda95fd__"